(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    let campusPrivacyBanner;
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-campus-cookie-settings]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        campusPrivacyBanner ??= new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = '/cdn/shopifycloud/privacy-banner/privacy-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.append(script);
        });
        await campusPrivacyBanner;
      }
      await window.privacyBanner.showPreferences();
    } catch {
      campusPrivacyBanner = undefined;
      window.location.assign(link.href);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
